import type { transitionHookFn } from "app/routes/handlers/redirectFunctions/redirectPipe";
import { BasicDurations } from "app/services/DurationService";

export const onRedirectAdjustGraphSwitcherParams: transitionHookFn = (transition) => {
    const params = { ...transition.params() };
    const { duration, graphDuration } = params;
    let updatedGraphDuration;
    if (duration == BasicDurations.LAST_TWENTY_EIGHT_DAYS && graphDuration === BasicDurations.LAST_MONTH) {
        updatedGraphDuration = BasicDurations.LAST_TWENTY_EIGHT_DAYS;
    }
    if (duration !== BasicDurations.LAST_TWENTY_EIGHT_DAYS && graphDuration === BasicDurations.LAST_TWENTY_EIGHT_DAYS) {
        updatedGraphDuration = BasicDurations.LAST_MONTH;
    }
    if (updatedGraphDuration) {
        return {
            params: { ...params, graphDuration: updatedGraphDuration },
        };
    }
};
